import { DataTransform } from 'app/models/data-transform';
import { DateService } from 'app/utils/services/date.service';
import { ISO_DATETIME_FORMAT_WITH_SECONDS, ISO_DATE_FORMAT, ISO_YEAR_MONTH_FORMAT } from '../constants';
import { FluidDatePipe } from '../pipes/fluidDate.pipe';

export abstract class DataTransformAbstractPost implements DataTransform {
  protected _fluidDatePipe: FluidDatePipe;

  transform(object: any) {
    console.log('transform down', object);
  }

  protected mapId(item: any, key: string = 'id') {
    if (!item) return item;
    return {
      [key]: item?.[key],
    };
  }

  protected mapIds(list: any, key: string = 'id') {
    return list?.map((item: any) => this.mapId(item, key));
  }

  protected normalizeTime(date: string | Date) {
    if (date) {
      return this._fluidDatePipe.transform(DateService.parse(date), ISO_DATETIME_FORMAT_WITH_SECONDS);
    }
  }

  protected normalizeMonth(date: string | Date) {
    if (date) {
      return this._fluidDatePipe.transform(DateService.parse(date), ISO_YEAR_MONTH_FORMAT);
    }
  }

  protected normalizeDate(date: string | Date) {
    if (date) {
      return this._fluidDatePipe.transform(DateService.parse(date), ISO_DATE_FORMAT);
    }
  }
}
